import script from "./text.vue?vue&type=script&lang=js"
export * from "./text.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/i18n/es/text.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eb7a2e54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eb7a2e54', __exports__)) {
    api.reload('eb7a2e54', __exports__)
  }
  
}


export default __exports__